import {
    Pipe,
    PipeTransform,
} from '@angular/core';

@Pipe({
    name: 'phone',
    pure: true,
    standalone: true,
})
export class PhonePipe implements PipeTransform {

    transform(tel: string): string {
        if (!tel?.length) {
            return tel;
        }
        return tel
            .toString()
            .trim()
            .replace(/[^+\d]/g, '')
            .replace(/^\+?1?(\d{3})(\d{3})(\d{4})$/, '($1) $2-$3')
            .replace(/^(\+?\d+)(\d{3})(\d{3})(\d{4})$/, '$1 ($2) $3-$4');
    }
}
